import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  HostListener,
  Inject,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { Location } from "@angular/common";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from "@angular/router";
import * as _ from "lodash";
import { FightTimeLineController } from "../../core/FightTimeLineController";
import * as M from "../../core/Models";
import * as FF from "../../core/FFLogs";
import { NgProgressbar } from "ngx-progressbar";
import { process } from "../../core/BossAttackProcessors";
import { SidepanelComponent } from "../../components/sidepanel/sidepanel.component";
import {
  PlanAreaComponent,
  Action,
  EventSource,
} from "./planArea/planArea.component";
import {
  ToolsManager,
  CopyPasteTool,
  DowntimeTool,
} from "../../core/ToolsManager";
import { PresenterManager } from "../../core/PresentationManager";

import { IdGenerator } from "../../core/Generators";
import { ICommandData } from "../../core/UndoRedo";
import * as Gameserviceprovider from "../../services/game.service-provider";
import * as GameServiceInterface from "../../services/game.service-interface";
import * as SerializeController from "../../core/SerializeController";
import * as Environment from "../../environments/environment";
import { VisStorageService } from "src/services/VisStorageService";
import { PingComponent } from "../../components/ping/ping.component";
import {
  ActivitySource,
  RecentActivityService,
} from "src/services/RecentActivitiesService";
import {
  DispatcherPayloads,
  DispatcherService,
} from "src/services/dispatcher.service";
import {
  fightServiceToken,
  IFightService,
  authenticationServiceToken,
  IAuthenticationService,
  ScreenNotificationsService,
  DialogService,
  SettingsService,
  LocalStorageService,
  FightHubService,
  IStartSessionHandlers,
  IConnectToSessionHandlers,
} from "src/services";
import { getTimeGoodAbilityToUse } from "src/core/Defensives/functions";
import { ChangeBossAttackCommand } from "src/core/commands/ChangeBossAttackCommand";
import { visibleFrameTemplate } from "src/core/Frame";

@Component({
  selector: "fightline",
  templateUrl: "./fightline.component.html",
  styleUrls: ["./fightline.component.css"],
})
export class FightLineComponent implements OnInit, OnDestroy {
  fightId: string;
  fflogsCode: string = null;

  @ViewChild("sidepanel", { static: true })
  sidepanel: SidepanelComponent;
  @ViewChild("progressBar", { static: true })
  progressBar: NgProgressbar;
  @ViewChild("planArea", { static: true })
  planArea: PlanAreaComponent;
  @ViewChildren(PingComponent) pings: QueryList<PingComponent>;

  fightLineController: FightTimeLineController;
  subs: any[] = [];

  private idgen = new IdGenerator();
  toolsManager = new ToolsManager();
  private presenterManager: PresenterManager;
  jobs = this.gameService.jobRegistry.getJobs();
  private worker: Worker;

  public constructor(
    private recent: RecentActivityService,
    @Inject(fightServiceToken) private fightService: IFightService,
    @Inject(Gameserviceprovider.gameServiceToken)
    public gameService: GameServiceInterface.IGameService,
    @Inject(authenticationServiceToken)
    public authenticationService: IAuthenticationService,
    @Inject("DispatcherPayloads")
    private dispatcher: DispatcherService<DispatcherPayloads>,
    private notification: ScreenNotificationsService,
    private visStorage: VisStorageService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router,
    private dialogService: DialogService,
    private settingsService: SettingsService,
    private storage: LocalStorageService,
    public fightHubService: FightHubService
  ) {
    this.presenterManager = visStorage.presenter;

    if (typeof Worker !== "undefined") {
      // Create a new
      this.worker = new Worker(
        new URL("../../app/warnings.worker", import.meta.url)
      );
      this.worker.onmessage = ({ data }) => {
        this.visStorage.holders.warnings = data.warnings;
      };
      this.processWarnings();
    } else {
      // Web workers are not supported in this environment.
      // You should add a fallback so that your program still executes correctly.
    }
  }

  processWarnings() {
    if (this.worker) {
      this.worker.postMessage({});
    }
  }

  onAction(event: Action) {
    if (this.toolsManager.handleAction(event)) {
      return;
    }

    const actionName = "on" + event.name[0].toUpperCase() + event.name.slice(1);
    if (this[actionName]) {
      this[actionName](event.source, event.payload);
    }
  }

  isWarningsVisible() {
    // return true;
    return Boolean(this.visStorage.holders.warnings.length);
  }

  onSelected(source: EventSource, event) {
    this.setSidePanel(event.data);
  }

  showWarnings() {
    this.setSidePanel("warnings");
  }

  onClickGroup(source: EventSource, event) {
    if (source === "player") {
      this.planArea.clearSelection();
      this.setSidePanel(event);
    }
  }

  useTool(t) {
    this.toolsManager.setActive(t);
  }

  onClickEmpty(source: EventSource, event) {
    const downtimesAtTime = this.fightLineController.getDowntimesAtTime(
      event.time
    );
    if (
      downtimesAtTime.length > 0 &&
      (source === "boss" ||
        (source === "player" &&
          this.presenterManager.view.showDowntimesInPartyArea))
    ) {
      event.items = downtimesAtTime.map((d) => d.id);
      this.planArea.clearSelection();

      this.setSidePanel(event);
    } else {
      this.planArea.updateSelection(source, event);
    }
  }

  onDoubleClickEmpty(source: EventSource, event) {
    this.fightLineController.notifyDoubleClick(
      event.item,
      event.group,
      new Date(event.time)
    );
  }

  onDoubleClickItem(source: EventSource, event) {
    this.fightLineController.notifyDoubleClick(
      event.item,
      event.group,
      new Date(event.time)
    );
  }

  onDoubleClickGroup(source: EventSource, event) {
    if (source === "player") {
      if (!this.fightLineController.isJobGroup(event.group)) {
        this.fightLineController.toggleCompactViewAbility(event.group);
        this.presenterManager.save(this.fightId);
      } else {
        this.fightLineController.toggleJobCollapsed(event.group);
        this.presenterManager.save(this.fightId);
      }
      setTimeout(() => this.planArea.refresh());
    }
  }

  onGroupOrderSwap(source: EventSource, event) {
    if (source === "player") {
      const from = event.from;
      const to = event.to;
      const fromJob = this.visStorage.holders.jobs.get(from.id);
      if (fromJob) {
        const toJob = this.visStorage.holders.jobs.get(to.id);
        if (toJob) {
          const ind = fromJob.index;
          fromJob.index = toJob.index;
          toJob.index = ind;

          event.handler(true);
          const fromAbs = this.visStorage.holders.abilities.getByParentId(
            fromJob.id
          );
          fromAbs.forEach((ab) => {
            ab.applyData({});
          });
          const toAbs = this.visStorage.holders.abilities.getByParentId(
            toJob.id
          );
          toAbs.forEach((ab) => {
            ab.applyData({});
          });

          this.visStorage.holders.abilities.update([...fromAbs, ...toAbs]);
        }
      } else {
        const abFrom = this.visStorage.holders.abilities.get(from.id);
        const abTo = this.visStorage.holders.abilities.get(to.id);
        if (abTo && abFrom && abTo.job.id === abFrom.job.id) {
          const ind = abFrom.index;
          abFrom.index = abTo.index;
          abTo.index = ind;
          const jf = this.presenterManager.jobFilter(abTo.job.id);
          jf.abilityOrder ||= {};
          jf.abilityOrder[abTo.ability.name] =
            abTo.index - Math.trunc(abTo.index);
          jf.abilityOrder[abFrom.ability.name] =
            abFrom.index - Math.trunc(abFrom.index);
          this.presenterManager.save(this.fightId);
          event.handler(true);
        }
      }
    }
  }

  onTimeChanged(source: EventSource, event) {
    this.fightLineController.notifyTimeChanged(event.id, event.date);
    this.sidepanel.refresh();
  }

  onDelete(source: EventSource, event) {
    this.fightLineController.handleDelete(event);
  }

  onMove(source: EventSource, event) {
    this.fightLineController.notifyMove(event);
  }

  onKeyMove(source: EventSource, event) {
    this.fightLineController.moveSelection(event.delta, event.selection);
  }

  onVisibleFrameTemplate(source: EventSource, event) {
    if (source === "player") {
      const html = visibleFrameTemplate(
        this.idgen,
        this.visStorage.holders,
        this.settingsService.load().colors,
        this.visStorage.presenter.view.statusesAsRows,
        this.visStorage.presenter.view.colorfulDurations,
        event.item
      );
      event.handler(html);
    }
  }

  onCanMove(source: EventSource, event) {
    const canMove = this.fightLineController.canMove(
      event.item,
      event.selection
    );
    if (canMove && source === "boss") {
      this.fightLineController.moveBossAttack(event.item);
    }
    event.handler(canMove);
  }

  onItemTooltip(source: EventSource, event) {
    event.handler(this.fightLineController.tooltipOnItemUpdateTime(event.item));
  }

  onTable(template: string) {
    window.open(
      this.router.serializeUrl(
        this.router.createUrlTree(["/table", this.fightId || "dummy", template])
      ),
      "_blank"
    );
  }

  // private openStanceSelector(data: M.IContextMenuData[]): void {
  //   //    this.contextMenu.openStanceSelector(data);
  // }

  exportToTable() {}

  private setSidePanel(eventData) {
    this.sidepanel.setSidePanel(eventData);
  }

  updateFilter(source?: string): void {
    this.visStorage.holders.level = this.presenterManager.fightLevel;
    this.fightLineController.applyFilter(null, source);
    this.sidepanel.refresh();
    this.presenterManager.save(this.fightId);
  }

  updateView($data?: M.IView): void {
    this.fightLineController.applyView($data);
    this.presenterManager.save(this.fightId);
    setTimeout(() => this.planArea.refresh());
  }

  presetChanged(preset: string): void {
    this.fightLineController.loadPreset(preset);
    this.location.replaceState(
      this.location.path(false).split("?")[0],
      "preset=" + encodeURIComponent(preset)
    );
  }

  openBossAttackAddDialog(
    bossAbility: M.IBossAbility,
    callBack: (b: any) => void
  ): void {
    this.dialogService.openBossAttackAddDialog(
      bossAbility,
      this.presenterManager,
      callBack
    );
  }

  load(): void {
    if (!this.authenticationService.authenticated) {
      this.notification.showSignInRequired(() => {});
      return;
    }

    this.dialogService.openLoad();
  }

  importFromFFLogs(code: string = null): void {
    this.dialogService
      .openImportFromFFLogs(code || this.fflogsCode)
      .then((result) => {
        if (!result) {
          return;
        }
        this.router.navigateByUrl(
          "fflogs/" + result.reportId + "/" + result.fightId
        );
      });
  }

  importBossAttacksFromFFLogs(code: string = null): void {
    this.dialogService
      .openImportFromFFLogs(code || this.fflogsCode, true)
      .then((result) => {
        if (!result) {
          return;
        }
        this.replaceBossFFLogsData(result.reportId, parseInt(result.fightId));
      });
  }

  loadFFLogsData(code: string, enc: number) {
    const stop = (ref: { close: () => void }) => {
      this.progressBar.complete();
      ref.close();
    };

    this.dialogService.executeWithLoading("Loading...", (ref) => {
      this.progressBar.start();
      this.gameService.dataService
        .getEvents(code, enc, {}, (percentage) =>
          this.progressBar.set(percentage * 100)
        )
        .then((parser) => {
          this.fightService.newFight("").subscribe(
            (value) => {
              this.fightId = value.id;
              this.location.replaceState("/" + value.id);
              this.startSession()
                .then(() => {
                  this.recent.register({
                    name: parser.fight.name,
                    boss: parser.fight.boss,
                    source: ActivitySource.FFLogs,
                    timestamp: new Date(),
                    url: "/" + value.id.toLowerCase(),
                    id: value.id.toLowerCase(),
                  });
                  const settings = this.settingsService.load();

                  try {
                    this.presenterManager.setSettings(settings);
                    this.fightLineController.importFromFFLogs(
                      code + ":" + enc,
                      parser
                    );
                    this.planArea.setInitialWindow(
                      this.fightLineController.getLatestAbilityUsageTime(),
                      2
                    );
                    this.planArea.refresh();
                  } catch (error) {
                    this.notification.error(
                      "We are unable to load this fight. Dev team is already informed about this case"
                    );
                  }
                  stop(ref);
                })
                .catch(() => {
                  stop(ref);
                });
            },
            (error) => {
              console.log(error);
              stop(ref);
              this.notification.error("Unable to start");
            }
          );
        })
        .catch((error) => {
          console.error(error);
          this.notification.showUnableToImport();
          stop(ref);
        });
    });
  }

  replaceBossFFLogsData(code: string, enc: number) {
    const stop = (ref: { close: () => void }) => {
      this.progressBar.complete();
      ref.close();
    };

    this.dialogService.executeWithLoading("Importing...", (ref) => {
      this.progressBar.start();
      this.gameService.dataService
        .getEvents(code, enc, { bossAttacksOnly: true }, (percentage) =>
          this.progressBar.set(percentage * 100)
        )
        .then((parser) => {
          try {
            this.fightLineController.importAttacksFromFFLogs(
              code + ":" + enc,
              parser
            );
            this.planArea.refresh();
          } catch (error) {
            this.notification.error(
              "We are unable to load this fight. Dev team is already informed about this case"
            );
          }
          stop(ref);
        })
        .catch((error) => {
          console.error(error);
          this.notification.showUnableToImport();
          stop(ref);
        });
    });
  }

  onNew() {
    this.router.navigateByUrl("/new");
  }

  saveFight(): void {
    if (!this.authenticationService.authenticated) {
      this.notification.showSignInRequired(() => {});
      return;
    }

    this.dialogService
      .openSaveFight(() =>
        this.fightLineController.createSerializer().serializeFight()
      )
      .then((result) => {
        if (result !== null && result !== undefined) {
          this.recent.register({
            name: result.name,
            url: "/" + result.id.toLowerCase(),
            source: ActivitySource.Timeline,
            id: result.id.toLowerCase(),
          });
          this.fightLineController.updateFight(result);
          this.location.replaceState(`/${result.id}`);
          this.notification.showFightSaved();
        }
      })
      .catch((reason) => {
        console.log(reason);
        this.notification.showFightNotSaved();
      });
  }

  addJob(jobName: string, actorName?: string): void {
    this.fightLineController.addJob(null, jobName, actorName, null, false);
  }

  showHelp(): Promise<void> {
    const promise = new Promise<void>((resolve) => {
      this.dialogService.openHelp().then(() => {
        this.storage.setString("help_shown", "yes");
        resolve();
      });
    });

    return promise;
  }

  openSettings(): void {
    this.dialogService.openSettings();
  }

  onUndo(): void {
    this.fightLineController.undo();
    this.planArea.refresh();
    this.onCommand({ name: "undo" });
  }

  onRedo(): void {
    this.fightLineController.redo();
    this.planArea.refresh();
    this.onCommand({ name: "redo" });
  }

  private startNew() {
    this.dialogService.executeWithLoading("Starting...", (ref) => {
      this.presenterManager.reset();

      const settings = this.settingsService.load();
      this.presenterManager.setSettings(settings);

      this.fightService.newFight("").subscribe(
        (value) => {
          this.fightId = value.id;
          this.location.replaceState("/" + value.id);
          this.recent.register({
            name: "New",
            url: "/" + value.id.toLowerCase(),
            source: ActivitySource.Timeline,
            id: value.id.toLowerCase(),
          });
          this.startSession().finally(() => {
            ref.close();
          });
        },
        (error) => {
          console.log(error);
          this.notification.error(
            "We are unable to connect to server. Your actions will not be stored."
          );
          ref.close();
        }
      );
    });
  }

  private loadFight(id: string, preset?: string) {
    this.dialogService.executeWithLoading("Loading...", (ref) => {
      this.presenterManager.reset();
      this.fightId = id;
      this.fightService.getFight(id).subscribe(
        (fight: M.IFight) => {
          if (fight) {
            this.recent.register({
              id: fight.id,
              name: fight.name,
              source: ActivitySource.Timeline,
              url: "/" + fight.id.toLowerCase(),
            });

            const settings = this.settingsService.load();
            this.presenterManager.setSettings(settings);

            const loadedData =
              fight.data &&
              (JSON.parse(
                fight.data
              ) as SerializeController.IFightSerializeData);
            if (loadedData.filter) {
              this.presenterManager.filter = loadedData.filter;
            }
            if (loadedData.view) {
              this.presenterManager.view = loadedData.view;
            }

            this.presenterManager.load(fight.id);

            this.fightService
              .getCommands(this.fightId, new Date(fight.dateModified).valueOf())
              .subscribe({
                next: (commands) => {
                  this.connectToSession()
                    .then(() => {
                      this.planArea.setInitialWindow(
                        this.fightLineController.getLatestBossAttackTime(),
                        2
                      );
                      this.planArea.refresh();
                    })
                    .finally(() => {
                      try {
                        this.fightLineController.loadFight(
                          fight,
                          loadedData,
                          commands.map((cmd) => JSON.parse(cmd.data))
                        );
                        if (preset) {
                          console.log("loading preset");
                          this.fightLineController.loadPreset(preset);
                        }
                      } catch (error) {
                        this.notification.error(
                          "We are unable to load this fight. Dev team is already informed about this case"
                        );
                      }
                      ref.close();
                    });
                },
                error: (error) => {
                  console.log(error);
                  this.notification.error("Unable to load data");
                  ref.close();
                },
              });
          } else {
            ref.close();
          }
        },
        () => {
          this.notification.showUnableToLoadFight(() => {});
          ref.close();
        }
      );
    });
  }

  private onStart(r: ActivatedRouteSnapshot): void {
    this.fflogsCode = null;
    const id = r.params.fightId;
    if (id) {
      if (id.indexOf("dummy") === 0) {
        this.loadFight("", r.queryParamMap.get("preset"));
      } else if (id === "new") {
        this.startNew();
      } else {
        this.loadFight(id, r.queryParamMap.get("preset"));
      }
    } else {
      const boss = r.params.boss;
      if (boss) {
        this.loadBoss(boss);
      } else {
        const code = r.params.code;
        if (code) {
          this.fflogsCode = code;
          const enc = r.params.fight;
          if (enc) {
            this.loadFFLogsData(code, +enc);
          } else {
            this.importFromFFLogs(code);
          }
        }
      }
    }
  }

  loadBoss(bossId: string) {
    this.dialogService.executeWithLoading("Loading...", (ref) => {
      const func = (fraction: M.IFraction, bossData: M.IBoss) => {
        this.fightService.newFight(fraction ? fraction.name : "").subscribe(
          (value) => {
            this.fightId = value.id;
            this.location.replaceState("/" + value.id);
            this.startSession()
              .then(() => {
                const settings = this.settingsService.load();

                this.presenterManager.setSettings(settings);

                this.fightLineController.fraction = fraction;
                this.fightLineController.applyView(settings.main.defaultView);
                this.fightLineController.applyFilter(
                  settings.main.defaultFilter
                );

                this.fightLineController.loadBoss(bossData);
                this.planArea.setInitialWindow(
                  this.fightLineController.getLatestBossAttackTime(),
                  2
                );
                this.planArea.refresh();
                ref.close();
              })
              .catch((error) => {
                console.log(error);
                this.notification.error("Unable to start");
                ref.close();
              });
          },
          (error) => {
            console.log(error);
            this.notification.error("Unable to start fight");
            ref.close();
          }
        );
      };

      this.fightService.getBoss(bossId).subscribe(
        (data) => {
          func(null, data);
        },
        (error) => {
          console.log(error);
          this.notification.error("Unable to start");
          ref.close();
        }
      );
    });
  }

  onCommand(data: ICommandData) {
    console.log("adding command in fightline.onCommand");
    this.fightService
      .addCommand(this.fightId, JSON.stringify(data))
      .subscribe((result) => {
        this.fightHubService.sendCommand(this.fightId, "", result.id);
      });
    this.sidepanel.refresh();
  }

  ngOnInit(): void {
    this.visStorage.clear();
    this.fightLineController = new FightTimeLineController(
      this.idgen,
      this.visStorage.holders,
      {
        openBossAttackAddDialog: this.openBossAttackAddDialog.bind(this),
      },
      this.gameService,
      this.settingsService,
      this.presenterManager
    );

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.fightLineController.downtimeChanged.subscribe(() => {
      this.toolsManager.refresh();
    });
    this.fightLineController.commandExecuted.subscribe((data: ICommandData) => {
      this.onCommand(data);
    });

    this.subscribeToDispatcher(this.dispatcher);

    this.toolsManager.register(
      new DowntimeTool(this.planArea, this.fightLineController)
    );
    this.toolsManager.register(new CopyPasteTool(this.fightLineController));

    setTimeout(() => {
      this.onStart(this.route.snapshot);
    });
  }

  startSession(): Promise<void> {
    if (!Environment.environment.production) {
      return Promise.resolve();
    }

    const promise = new Promise<void>((resolve, reject) => {
      const handlers: IStartSessionHandlers = {
        onCommand: ((data: M.IHubCommand) =>
          this.handleRemoteCommand(data.id, data.userId)).bind(this),
        onConnected: ((data: M.IHubUser) =>
          this.notification.showUserConnected(data)).bind(this),
        onDisconnected: ((data: M.IHubUser) =>
          this.notification.showUserDisconnected(data)).bind(this),
      };

      const settings = this.settingsService.load();
      const name =
        settings.teamwork.displayName ||
        this.authenticationService.username ||
        "Anonymous";

      this.fightHubService
        .startSession(this.fightId, name, handlers)
        .then(() => {
          this.notification.showSessionStarted();
          resolve();
        })
        .catch(() => {
          this.notification.showUnableToStartSession();
          reject();
        });
    });
    return promise;
  }

  stopSession() {
    this.fightHubService.disconnect(this.fightId);
  }

  handleRemoteCommand(id: string, userId: string) {
    this.ping(userId, false);

    this.fightService.getCommand(+id).subscribe(
      (data: ICommandData) => {
        this.handleRemoteCommandData(data);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  ping(id: string, owner: boolean): void {
    const pingComponent = this.pings.find(
      (it) => it.id === id || (owner && it.owner === owner)
    );
    if (pingComponent) {
      pingComponent.ping();
    }
  }

  handleRemoteCommandData(data: ICommandData) {
    this.fightLineController.execute(data);
    this.planArea.refresh();
  }

  connectToSession() {
    const handlers: IConnectToSessionHandlers = {
      onCommand: ((data: M.IHubCommand) =>
        this.handleRemoteCommand(data.id, data.userId)).bind(this),
      onConnected: ((data: M.IHubUser) =>
        this.notification.showUserConnected(data)).bind(this),
      onDisconnected: ((data: M.IHubUser) =>
        this.notification.showUserDisconnected(data)).bind(this),
    };

    const settings = this.settingsService.load();
    const name =
      settings.teamwork.displayName ||
      this.authenticationService.username ||
      "Anonymous";
    return this.fightHubService
      .connect(this.fightId, name, handlers)
      .then(() => {
        this.notification.showConnectedToSession();
      })
      .catch(() => {
        this.notification.showConnectedToSessionError();
      });
  }

  @HostListener("window:beforeunload", ["$event"])
  beforeUnloadHandler(event: any) {
    //    if (this.hasChanges && Environment.environment.showDialogOnUnload) {
    //      event.returnValue = "You have unsaved changes. Are you sure you want to leave?";
    //      return event.returnValue;
    //    }
    return null;
  }

  @HostListener("window:unload", ["$event"])
  unloadHandler(event: any) {
    this.stopSession();
  }

  get hasChanges(): boolean {
    return this.fightLineController.hasChanges;
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
    this.stopSession();
    this.dispatcher.destroy();
  }

  showAsTable() {
    this.dialogService.openTable();
  }

  openBossTemplates() {
    const boss = this.fightLineController.data.boss;
    this.dialogService.openBossTemplates(true, boss);
  }

  attachPreset(data: { name: string; preset: M.IPresetTemplate }) {
    this.fightLineController.attachPreset(data.name, data.preset);
  }

  exportData(format) {
    const saveData = (() => {
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);
      return (data: Blob, fileName: string) => {
        const url = window.URL.createObjectURL(data);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      };
    })();

    const serializer = this.fightLineController.createSerializer();
    const exported = serializer.serializeForDownload();
    const blob = new Blob([JSON.stringify(exported, null, 2)], {
      type: "application/json",
    });
    saveData(blob, "data.json");
  }

  private subscribeToDispatcher(
    dispatcher: DispatcherService<DispatcherPayloads>
  ) {
    dispatcher.on("similarClick").subscribe((value) => {
      this.planArea.selectBossAttacks([value]);
      this.sidepanel.setItems(this.fightLineController.getItems([value]));
    });

    dispatcher.on("similarAllClick").subscribe((value) => {
      this.planArea.selectBossAttacks(value);
      this.sidepanel.setItems(this.fightLineController.getItems(value));
    });

    dispatcher.on("abilityClick").subscribe((value) => {
      this.planArea.selectAbilities([value]);
      this.sidepanel.setItems(this.fightLineController.getItems([value]));
    });

    dispatcher.on("attacksSetColor").subscribe(({ ids, color }) => {
      this.fightLineController.combineAndExecute(
        ids.map((id) => {
          const ba = this.visStorage.holders.bossAttacks.get(id);
          return new ChangeBossAttackCommand(
            id,
            { ...ba.attack, color: color },
            false
          );
        })
      );
    });

    dispatcher.on("bossTemplateSave").subscribe((value) => {
      const bossData = this.fightLineController
        .createSerializer()
        .serializeBoss();

      if (bossData.id) {
        this.fightService.saveBoss(bossData).subscribe({
          next: (e) => {
            this.notification.success("Boss saved");
            this.fightLineController.updateBoss(e);
            value.close();
          },
          error: (err) => {
            console.error(err);
            this.notification.error("Boss save failed");
          },
        });
      } else {
        this.dialogService
          .openSaveBoss(value.name + " new template")
          .then((data) => {
            if (data) {
              bossData.name = data;
              bossData.userName =
                (bossData && bossData.userName) ||
                this.authenticationService.username;
              bossData.ref = (bossData && bossData.ref) || value.reference;
              bossData.isPrivate =
                (bossData && bossData.isPrivate) || value.isPrivate;
              bossData.game = this.gameService.name;

              this.fightService.saveBoss(bossData).subscribe({
                next: (e) => {
                  this.notification.success("Boss saved");
                  this.fightLineController.updateBoss(e);
                  value.close();
                },
                error: (err) => {
                  console.log(err);
                  this.notification.error("Boss save failed");
                },
              });
            } else {
              value.close();
            }
          });
      }
    });

    dispatcher.on("changeJobStats").subscribe((value) => {
      this.fightLineController.setJobStats(value.id, value.data);
    });

    dispatcher.on("toggleAttackPin").subscribe((value) => {
      this.fightLineController.toggleBossAttackPin(value);
    });

    dispatcher.on("bossTemplateSaveAsNew").subscribe((value) => {
      const bossData = this.fightLineController
        .createSerializer()
        .serializeBoss();
      this.dialogService
        .openSaveBoss(value.name + " new template")
        .then((data) => {
          if (data) {
            bossData.id = null;
            bossData.name = data;
            bossData.userName =
              (bossData && bossData.userName) ||
              this.authenticationService.username;
            bossData.ref = (bossData && bossData.ref) || value.reference;
            bossData.isPrivate =
              (bossData && bossData.isPrivate) || value.isPrivate;
            bossData.game = this.gameService.name;

            this.fightService.saveBoss(bossData).subscribe({
              next: (e) => {
                this.notification.success("Boss saved");
                this.fightLineController.updateBoss(e);
                value.close();
              },
              error: (err) => {
                console.log(err);
                this.notification.error("Boss save failed");
              },
            });
          } else {
            value.close();
          }
        });
    });

    dispatcher.on("updateSettings").subscribe(() => {
      this.fightLineController.colorSettings =
        this.settingsService.load().colors;
      this.planArea.refresh();
    });

    dispatcher.on("removeJob").subscribe((value) => {
      this.fightLineController.removeJob(value);
      this.setSidePanel(null);
    });

    dispatcher.on("attackCopy").subscribe((value) => {
      this.fightLineController.copy(value);
      this.toolsManager.setActive("Copy & Paste");
    });

    dispatcher.on("attackEdit").subscribe((value) => {
      this.fightLineController.updateBossAttack(value);
    });

    dispatcher.on("updateFilter").subscribe((value) => {
      this.updateFilter();
    });

    dispatcher.on("updateView").subscribe((value) => {
      this.updateView();
    });

    // dispatcher.on("SidePanel Ability Settings").subscribe(value => {
    //   this.fightLineController.editAbility(value.id);
    // });

    dispatcher.on("abilitySaveSettings").subscribe((value) => {
      this.fightLineController.updateAbilitySettings(value.id, value.settings);
    });

    dispatcher.on("hideJobAbility").subscribe((value) => {
      this.fightLineController.hideAbility(value);
      this.setSidePanel(null);
      this.presenterManager.save(this.fightId);
    });

    dispatcher.on("clearJobAbility").subscribe((value) => {
      this.fightLineController.clearAbility(value);
      this.setSidePanel(null);
    });

    dispatcher.on("fillJobAbility").subscribe((value) => {
      this.fightLineController.combineAndExecute(
        this.fightLineController.fillAbility(value)
      );
    });

    dispatcher.on("fillJob").subscribe((value) => {
      this.fightLineController.combineAndExecute(
        this.fightLineController.fillJob(value)
      );
    });

    dispatcher.on("jobAbilityRestoreAll").subscribe((value) => {
      const hidden = [...this.presenterManager.jobFilter(value).abilityHidden];
      hidden?.forEach((h) => {
        const ab = this.visStorage.holders.abilities.getByParentAndAbility(
          value,
          h
        );
        this.fightLineController.showAbility(ab.id);
      });
      this.presenterManager.save(this.fightId);
    });

    dispatcher.on("jobAbilityRestore").subscribe((value) => {
      this.fightLineController.showAbility(value);
      this.presenterManager.save(this.fightId);
    });

    dispatcher.on("toggleJobCompactView").subscribe((value) => {
      this.fightLineController.toggleJobCompactView(value);
      this.fightLineController.applyFilter();
      this.presenterManager.save(this.fightId);
    });

    dispatcher.on("availAbilityClick").subscribe(({ abilityMap, attackId }) => {
      const attack = this.visStorage.holders.bossAttacks.get(attackId);
      const at = getTimeGoodAbilityToUse(
        this.visStorage.holders,
        abilityMap,
        attack
      );

      this.fightLineController.addClassAbility(null, abilityMap, at, false);
    });

    dispatcher.on("toggleJobAbilityCompactView").subscribe((value) => {
      this.fightLineController.toggleCompactViewAbility(value);
      // this.fightLineController.applyFilter();
      this.presenterManager.save(this.fightId);
    });

    dispatcher.on("downTimeColor").subscribe((value) => {
      this.fightLineController.setDownTimeColor(value.id, value.color);
    });

    dispatcher.on("downtimeComment").subscribe((value) => {
      this.fightLineController.setDownTimeComment(value.id, value.comment);
    });

    dispatcher.on("abilitiesRemove").subscribe((value) => {
      this.fightLineController.handleDelete(value);
    });

    dispatcher.on("attacksRemove").subscribe((value) => {
      this.fightLineController.handleDelete(value);
    });

    dispatcher.on("downtimeRemove").subscribe((value) => {
      this.fightLineController.removeDownTime(value);
      this.setSidePanel(null);
    });

    dispatcher.on("selectDowntimes").subscribe((value) => {
      this.setSidePanel({
        items: [value],
      });
    });

    dispatcher.on("bossTemplatesLoad").subscribe(async (value) => {
      this.dialogService.executeWithLoading("Loading...", async (ref) => {
        const stop = (dialog: { close: () => void }) => {
          value.close();
          this.progressBar.complete();
          dialog.close();
        };

        this.progressBar.start();
        const source = this.fightLineController.data.importedFrom;
        if (source) {
          const [code, fight] = source.split(":");
          const parser = await this.gameService.dataService.getEvents(
            code,
            +fight,
            { bossAttacksOnly: true },
            (percentage) => this.progressBar.set(percentage * 100)
          );

          const enemyAttacks = parser.events.filter((it: FF.AbilityEvent) => {
            return (
              !it.sourceIsFriendly &&
              it.ability &&
              it.ability.name.toLowerCase() !== "attack" &&
              it.ability.name.trim() !== "" &&
              it.ability.name.indexOf("Unknown_") < 0
            );
          });
          const g = _.groupBy(
            enemyAttacks as FF.AbilityEvent[],
            (d) => d.ability.name + "_" + Math.trunc(d.timestamp / 1000)
          );
          const attacks: FF.AbilityEvent[] = Object.keys(g).map((k: string) => {
            return g[k][0];
          });

          const bossData = JSON.parse(
            value.boss.data
          ) as SerializeController.IBossSerializeData;
          const result = process(
            attacks,
            parser.fight.start_time,
            bossData.attacks.map((it) => it.ability),
            bossData.downTimes
          );
          bossData.attacks = result.map(
            (it) =>
              ({
                ability: it,
                id: this.idgen.getNextId(M.EntryType.BossAttack),
              } as SerializeController.IBossAbilityUsageData)
          );
          value.boss.data = JSON.stringify(bossData);
          this.fightLineController.loadBoss(value.boss);
          stop(ref);
        } else {
          this.fightLineController.loadBoss(value.boss);
          stop(ref);
        }
      });
    });
  }
}
